(function() {
'use strict';
if (window.__colorboxFaqInit) return;
window.__colorboxFaqInit = true;
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.faq-trigger');
  if (!btn) return;
  var item = btn.closest('.faq-item');
  if (!item) return;
  var answer = item.querySelector('.faq-answer');
  var plus = item.querySelector('.faq-icon-plus');
  var minus = item.querySelector('.faq-icon-minus');
  var expanded = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', String(!expanded));
  if (expanded) {
    answer.style.maxHeight = '0';
    plus.classList.remove('hidden');
    minus.classList.add('hidden');
  } else {
    answer.style.maxHeight = answer.scrollHeight + 'px';
    plus.classList.add('hidden');
    minus.classList.remove('hidden');
  }
});
})();
